var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 958,
    height: 570,
    viewBox: "0 0 958 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-109 15.3772C23.3474 15.3772 156.591 20.4146 288.778 12.2661C329.969 9.72697 371.101 6.15104 412.333 4.26613C532.982 -1.24926 599.313 3.59942 720 5.5C756.968 6.08218 842.795 15.9802 878 26C906 37.5 920.549 44.9266 935.889 60.2661C957.123 81.5 957.797 98.9541 954.778 121.599C951.148 148.825 921.436 168.159 899 179.377C874.906 191.424 852 198.5 821.889 203.599C804.522 208.561 765.89 208.374 755.889 227.377C746.422 245.365 761.5 259 782.111 279.377C800.51 297.567 797 324.5 788 340C772.613 366.5 732.99 365.389 713.5 378C698.557 387.669 688.557 404.475 686.778 421.377C683.716 450.466 668 475.5 638.5 498C590 534.992 535.939 547.753 480.778 555.377C365.84 571.263 248.362 567.377 132.556 567.377C77.0899 567.377 21.7058 563.377 -33.8889 563.377C-69.963 563.377 -106.037 563.377 -142.111 563.377C-157.487 563.377 -175.206 566.274 -189 559.377",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBg);
export default __webpack_public_path__ + "static/media/line-bg.ea6b6336c57a1f02b1cf19ffac9ee48c.svg";
export { ForwardRef as ReactComponent };